const TestIds = {
	AccountSelect: 'accountSelect',
	AccountSelectValue: 'accountSelect.value',
	AccountSelectInput: 'accountSelect.input',
	AccountSelectOptions: 'accountSelect.options',
	AccountSelectOption_0: 'accountSelect.options.0',
	SelectInput: 'selectInput',
	SelectInputInput: 'selectInput.input',
	SelectInputOptions: 'selectInput.options',
	SelectInputOption_0: 'selectInput.options.0',
	SelectValue: 'selectInput.value',
	DatePicker: 'datePicker',
	DatePickerDay_0: 'datePicker.day.0',
	Content: 'content',
	Countdown: 'countdown',
	Donation: 'donation',
	DonationCurrencySelect: 'donation.currencySelect',
	DonationCurrencySelectConfirm: 'donation.currencySelect.confirm',
	DonationDonate: 'donation.donate',
	DonationAddress: 'donation.address',
	DonationMessage: 'donation.message',
	DonationMessageWarning: 'donation.messageWarning',
	DonationHeader: 'paymentHeader',
	DonationHeaderId: 'paymentHeader.id',
	DonationHeaderDescription: 'paymentHeader.description',
	DonationHeaderCurrencyInfo: 'paymentHeader.currencyInfo',
	DonationHeaderCurrencyInfoCurrency_0: 'paymentHeader.currencyInfo.currency.0',
	Footer: 'footer',
	FooterLink: 'footer.link',
	FormError: 'formError',
	Header: 'header',
	HeaderName: 'header.name',
	HeaderBadge: 'header.badge',
	HeaderMenu: 'header.menu',
	HeaderMenuToggle: 'header.menu.toggle',
	HeaderMenuList: 'header.menu.list',
	HeaderMenuListItem: 'header.menu.list.item',
	Loader: 'loader',
	MessageBlock: 'messageBlock',
	Order: 'order',
	OrderAddress: 'order.address',
	OrderCountdown: 'order.countdown',
	OrderMessage: 'order.message',
	OrderMessageWarning: 'order.messageWarning',
	OrderCancelError: 'order.cancelError',
	OrderCancel: 'order.cancel',
	OrderAmount: 'order.amount',
	OrderCoin: 'order.coin',
	OrderNetwork: 'order.network',
	OrderPayWithSc: 'order.payWithSc',
	OrderStatusPaid: 'orderStatus.paid',
	OrderStatusPending: 'orderStatus.pending',
	OrderStatusFailed: 'orderStatus.failed',
	OrderStatusExpired: 'orderStatus.expired',
	OrderStatusLink: 'orderStatus.link',
	OrderStatusGetInvoice: 'orderStatus.getInvoice',
	PaymentHeader: 'paymentHeader',
	PaymentHeaderPayAmount: 'paymentHeader.payAmount',
	PaymentHeaderReceiveAmount: 'paymentHeader.receiveAmount',
	PaymentHeaderOrderId: 'paymentHeader.orderId',
	PaymentHeaderDescription: 'paymentHeader.description',
	PaymentHeaderCurrencyInfo: 'paymentHeader.currencyInfo',
	PaymentHeaderCurrencyInfoCurrency_0: 'paymentHeader.currencyInfo.currency.0',
	PaymentHeaderNetworkInfo: 'paymentHeader.networkInfo',
	PaymentHeaderNetworkInfoNetwork_0: 'paymentHeader.networkInfo.network.0',
	Preorder: 'preorder',
	PreorderTravelRuleConfirm: 'preorder.travelRule.confirm',
	PreorderTravelRulePaymentInfo: 'preorder.travelRule.paymentInfo',
	PreorderTravelRuleTypeSelect: 'preorder.travelRule.typeSelect',
	PreorderTravelRuleTypePersonal: 'preorder.travelRule.typePersonal',
	PreorderTravelRuleTypeBusiness: 'preorder.travelRule.typeBusiness',
	PreorderTravelRuleFirstNameInput: 'preorder.travelRule.firstNameInput',
	PreorderTravelRuleLastNameInput: 'preorder.travelRule.lastNameInput',
	PreorderTravelRuleDateOfBirthInput: 'preorder.travelRule.dateOfBirthInput',
	PreorderTravelRuleCompanyNameInput: 'preorder.travelRule.companyNameInput',
	PreorderTravelRuleCompanyCodeInput: 'preorder.travelRule.companyCodeInput',
	PreorderTravelRuleCountryOfResidenceInput: 'preorder.travelRule.countryOfResidenceInput',
	PreorderTravelRuleCountryOfRegistrationInput: 'preorder.travelRule.countryOfRegistrationInput',
	PreorderTravelRuleEmailInput: 'preorder.travelRule.emailInput',
	PreorderTravelRuleSaveInformationCheckbox: 'preorder.travelRule.saveInformationCheckbox',
	PreorderTravelRuleConfirmCheckbox: 'preorder.travelRule.confirmCheckbox',
	PreorderCurrency: 'preorder.currency',
	PreorderCurrencySelectedCurrency: 'preorder.currency.selectedCurrency',
	PreorderCurrencyCurrencyOption_0: 'preorder.currency.currencyOption.0',
	PreorderCurrencyConfirm: 'preorder.currency.confirm',
	PreorderCurrencyVolatility: 'preorder.currency.volatility',
	PreorderCurrencyPaymentInfo: 'preorder.currency.paymentInfo',
	PreorderCurrencyCreateOrderError: 'preorder.currency.createOrderError',
	PreorderCurrencyNoPaymentOptionsError: 'preorder.currency.noPaymentOptions',
	PreorderNetwork: 'preorder.network',
	PreorderNetwork_0: 'preorder.network.0',
	PreorderNetworkConfirm: 'preorder.network.confirm',
	PreorderNetworkNetworksError: 'preorder.network.networksError',
	PreorderNetworkCreateError: 'preorder.network.createError',
	PreorderNetworkNoNetworks: 'preorder.currency.noNetworks',
	ProgressBar: 'progressBar',
	PublicForm: 'publicForm',
	PublicFormReceiveAmount: 'publicForm.receiveAmount',
	PublicFormReceiveAmountSelectedCurrency: 'publicForm.receiveAmount.selectedCurrency',
	PublicFormReceiveAmountSelectedCurrencyInput: 'publicForm.receiveAmount.selectedCurrency.input',
	PublicFormReceiveAmountSingleCurrency: 'publicForm.receiveAmount.singleCurrency',
	PublicFormOrderIdField: 'publicForm.orderId.field',
	PublicFormOrderIdInput: 'publicform.orderId.input',
	PublicFormDescriptionField: 'publicForm.description.field',
	PublicFormDescriptionInput: 'publicform.description.input',
	PublicFormSubmit: 'publicForm.submit',
	QR: 'qr',
	QRView: 'qrView',
	QRInfoMessage: 'qr.infoMessage',
	CopyQR: 'copyQR',
	ShowQR: 'showQR',
	Toggle: 'toggle',
	Settings: 'settings',
	SettingsOptions: 'settings.options',
} as const;

export const formatTestId = (token: typeof TestIds[keyof typeof TestIds], insert?: string) =>
	token.replace('0', insert || '?') as typeof TestIds[keyof typeof TestIds];

export default TestIds;
